import React from "react";

interface CheckBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  onChange?: () => void;
  checked?: boolean | false;
  error?: string | null;
  labelClassName?: string;
}

export function CheckBox({
  label,
  onChange,
  checked,
  error,
  labelClassName,
  ...props
}: CheckBoxProps) {
  return (
    <div className="mb-4">
      <label
        className={`flex items-center gap-2 w-fit cursor-pointer ${labelClassName}`}
      >
        <input
          key={label}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="relative w-6 h-6 shrink-0 cursor-pointer rounded-[7px] border border-[#333333] bg-[#1D1D1D] appearance-none checked:bg-[#1D1D1D] checked:border-[#333333] checked:after:content-[''] checked:after:absolute checked:after:w-[12px] checked:after:h-[6px] checked:after:border-l-2 checked:after:border-b-2 checked:after:border-[#CFCFCF] checked:after:rotate-[-45deg] checked:after:left-[6px] checked:after:top-[7px]"
          {...props}
        />
        {label}
      </label>
      {error && <div className="text-red-500 text-sm mt-1 ml-2">{error}</div>}
    </div>
  );
}
